import React from 'react';
import CrudPage from '../../components/CrudPage';
import { topupTransactionApi } from '../../services/adminApi';

const columns = [
  { header: 'ID', field: 'id' },
  { header: 'Investor ID', field: 'investorId' },
  { header: 'Amount', field: 'amount', render: (v) => v ? `£${Number(v).toLocaleString()}` : '-' },
  { header: 'Currency', field: 'currency', render: (v) => v || '-' },
  { header: 'Payment Method', field: 'paymentMethod', render: (v) => v || '-' },
  { header: 'Payment Provider', field: 'paymentProvider', render: (v) => v || '-' },
  { header: 'Reference', field: 'reference', render: (v) => v || '-' },
  { header: 'Status', field: 'status', render: (v) => v || '-' },
  { header: 'Created', field: 'createdAt', type: 'date' },
];

const formFields = [
  { name: 'investorId', label: 'Investor ID', type: 'text', required: true },
  { name: 'amount', label: 'Amount', type: 'number', required: true },
  { name: 'currency', label: 'Currency', type: 'text' },
  { name: 'paymentMethod', label: 'Payment Method', type: 'text' },
  { name: 'paymentProvider', label: 'Payment Provider', type: 'text' },
  { name: 'reference', label: 'Reference', type: 'text' },
  { name: 'status', label: 'Status', type: 'select', options: [
    { value: 'pending', label: 'Pending' },
    { value: 'completed', label: 'Completed' },
    { value: 'failed', label: 'Failed' },
  ]},
];

const TopupTransactionPage = () => (
  <CrudPage
    title="Top-up Transactions"
    subtitle="Manage top-up transactions"
    api={topupTransactionApi}
    columns={columns}
    formFields={formFields}
    idField="id"
  />
);

export default TopupTransactionPage;
